import { useEffect, useRef } from 'react';

export const useReportLoadError = ({ onLoadError, error, retry }) => {
  const onLoadErrorRef = useRef(onLoadError);
  onLoadErrorRef.current = onLoadError;

  useEffect(() => {
    const message = typeof error === 'string' ? error : error?.error;
    onLoadErrorRef.current?.(error ? { message, retry } : null);
  }, [error, retry]);

  useEffect(() => () => onLoadErrorRef.current?.(null), []);
};
